import axios from 'axios';

let conf = window.equicareLocalConfiguration;
if (!conf) {
  conf = {
    apiUrl: {
      hostname: '',
      port: '',
    },
  };
}

let wholePath = '//'.concat(conf.apiUrl.hostname);
if (conf.apiUrl.port && conf.apiUrl.port.trim().length > 0) {
  wholePath = wholePath.concat(':').concat(conf.apiUrl.port);
}
const axiosInstance = axios.create({
  baseURL: wholePath,
  headers: {
    'portal-type': 'patientPortal',
  },
});

export default axiosInstance;

